import React from 'react';
import { TestimonialsSection } from './TestimonialsSection';
const data = [{
  initials: 'MR',
  quote: 'Llevaba 2 años sin poder tener una conversación real con mi hijo. Con el Tomo 2 entendí por qué explotaba. Con el Tomo 5 aprendí a acercarme diferente. Hoy hablamos.',
  name: 'Marcela R.',
  location: 'Buenos Aires',
  role: 'Madre de adolescente de 16 años'
}, {
  initials: 'RT',
  quote: 'Lo integré en mis sesiones de tutoría y el cambio en los estudiantes fue visible en semanas. Tienen vocabulario emocional que antes no tenían.',
  name: 'Rodrigo T.',
  location: 'Córdoba',
  role: 'Docente de Secundaria'
}, {
  initials: 'CV',
  quote: 'Como terapeuta buscaba recursos estructurados para adolescentes. Este sistema es exactamente lo que mis pacientes necesitaban para trabajar entre sesiones.',
  name: 'Dra. Carmen V.',
  location: 'Santiago de Chile',
  role: 'Psicóloga Clínica'
}];
export function Testimonials1() {
  return <TestimonialsSection title="Lo que Dicen Quienes Ya Empezaron su Transformación" testimonials={data} data-id="element-274" />;
}